export default "__VITE_ASSET__7d2e06b6__"